export default {
    namespaced: true,
    state: {
      active: false,
      msg: 'Are you sure to delete this?',
      extraMsg: "We wouldn't want you to do that by mistake!",
      resolve: null,
      reject: null
    },
    getters: {
        active: state => state.active,
        msg: state => state.msg,
        extraMsg: state => state.extraMsg,
        resolve: state => state.resolve,
        reject: state => state.reject
    },
    mutations: {
        active(state){
            state.active = false
        },
        accept(state){
            state.active = false
            state.resolve()
        },
        reject(state){
            state.active = false
        }
    },
    actions: {
        confirm(context, content){
            context.state.active = true
            context.state.msg = content.msg
            context.state.extraMsg = content.extraMsg?content.extraMsg:"We wouldn't want you to do that by mistake!"
            return new Promise((resolve, reject) => {
                context.state.resolve = resolve
                context.state.reject = reject
            })
        }
    }
  };
  